import { SnMapClusterPoint } from '@lib/api';
import { GoogleMapClusterMarker } from '@lib/geo/google/map';

export class SnLocationClusterMarker extends GoogleMapClusterMarker {
  constructor(cluster: SnMapClusterPoint) {
    super(cluster, {
      style: {
        fillOpacity: 0,
        strokeOpacity: 0,
        scale: 1.4,
      },
      icon: {
        fontIcon: 'Icon_Other',
        fontSet: 'fs',
      },
    });
  }
}
